import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

interface DownloadUrlResponse {
  downloadUrl: string;
  fileName: string;
}

interface DownloadUrlArgs {
  matterId: string;
  exportId: string;
}

/**
 * Resolves the download URL for any completed export by ID. Backed by the
 * cache the consumer writes at completion time, so the dialog doesn't need
 * to know which feature produced the export.
 */
export const useGetExportDownloadUrl = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useMutation(async ({ matterId, exportId }: DownloadUrlArgs): Promise<DownloadUrlResponse> => {
    const response = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/exports/${exportId}/download-url`,
      fetchConfigGET,
    );
    if (!response.ok) {
      const body = (await response.json().catch(() => null)) as { message?: string | string[] } | null;
      const message = Array.isArray(body?.message) ? body?.message.join(', ') : body?.message;
      throw new Error(message || 'Failed to get export download URL');
    }
    return (await response.json()) as DownloadUrlResponse;
  });
};
